import { Component, ElementRef, HostListener, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Readiness } from '../shared/services/shell-context.service';
import { IconComponent } from '../shared/components/icon/icon.component';

/**
 * "Ready 4/6" pill in the builder topbar (mockup v3 shell.jsx ReadinessPill).
 * Click opens the readiness-coach checklist; unmet items jump to the section
 * that fixes them.
 */
@Component({
  selector: 'app-readiness-pill',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './readiness-pill.component.html',
  styleUrls: ['./readiness-pill.component.scss'],
})
export class ReadinessPillComponent {
  readiness = input.required<Readiness>();
  jump = output<string>();

  readonly open = signal<boolean>(false);

  private readonly host = inject(ElementRef<HTMLElement>);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.open() && !this.host.nativeElement.contains(event.target as Node)) {
      this.open.set(false);
    }
  }

  onItem(section: string | null): void {
    if (!section) return;
    this.jump.emit(section);
    this.open.set(false);
  }
}
